<script setup lang="ts">
/**
 * A link in a message (ZhMarkdown, ZhTypedText): the system cyan the thread's own "Open →" uses. It opens in a new
 * tab, so the chat stays where it was, and tells the page it opens nothing of where it came from.
 */
defineProps<{
    /** A destination lib/markdown.ts allowed: `http:`, `https:` or `mailto:`. */
    href: string
}>()
</script>

<template>
    <a class="zh-link" :href="href" target="_blank" rel="noopener noreferrer"><slot /></a>
</template>

<style scoped>
.zh-link {
    color: var(--electric-cyan);
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 0.2em;
}

.zh-link:hover {
    color: color-mix(in srgb, var(--electric-cyan) 80%, var(--dirty-white));
}
</style>
